export enum AuditType {
  MarketplaceView = 'MarketplaceView',
  MarketplaceFavoriteView = 'MarketplaceFavoriteView',
  DeclineBooking = 'DeclineBooking',
  FavoritesMatchEmailView = 'FavoritesMatchEmailView',
  ReadyToBookEmailView = 'ReadyToBookEmailView',
}
